import {action, observable, runInAction} from 'mobx';
import {decorate, inject, injectable} from '@yosmanyga/di';
import {Dispatcher} from '@yosmanyga/base';

class PlayBoardController {
    @observable accessor scenery: Array<{
        input: string;
        output: Array<string>;
    }>;

    constructor(private dispatcher: Dispatcher) {
        this.scenery = [];

        this.dispatcher.register(
            'play_input_executed',
            this.listenToPlayInputExecuted
        );
    }

    @action select = (value: string) => {
        this.dispatcher
            .retrieve<(note: string) => void>('play_board_output_selected')
            .forEach((service) => {
                service(value);
            });
    };

    @action listenToPlayInputExecuted = async ({input, lines}: { input: string, lines: string[] }) => {
        runInAction(() => {
            this.scenery = [
                ...(lines.length < 4 ? this.scenery : []),
                {
                    input: input,
                    output: lines,
                },
            ];
        });
    };
}

decorate(injectable(), PlayBoardController);
decorate(inject(Dispatcher), PlayBoardController, 0);

export {PlayBoardController};
